import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormAddReseller } from "./FormAddReseller";

export const PanelAddReseller = () => {
  return (
    <div>
      {" "}
      <PanelHead
        title={
          <div className="flex items-center justify-between w-full gap-4">
            <div>Add Reseller Page</div>
          </div>
        }
      />
      <PanelBody content={<FormAddReseller />} />
    </div>
  );
};
